import * as React from "react";
import {cs} from "../../../../../../../../../../../../react/chain-services";
import "./new-address-modal.scss";
import {ModalService3} from "../../../../../../../../../../../modal-service-3/modal-service-3";
import {Select} from "../../../../../../../../../../common/design2/select/select";
import {UseState} from "../../../../../../../../../../../../react/use-state";
import {cx} from "emotion";

export const NewAddressModal = ({buildingSelector, addBuilding, isBuildingExisted, next: rootNext}) => cs(
    ["modal", ({modalClosed}, next) => ModalService3({
        width: 324,
        rootNext,
        xdQaName: "New Address",
        next,
    })],
    ["form", (_, next) => buildingSelector.renderForm({next})],
    ({form, modal}) => (
        <div className="new-address-modal new-address-modal-32h">
            <div className="header">
                Add Address
            </div>

            <div className="content">
                <div className="form-group">
                    <div className="control-label">
                        Find Buildings on Street
                    </div>

                    {Select({
                        list: form.streets,
                        isSelected: form.isStreetSelected,
                        onChange: form.onSelectStreet,
                        itemToLabel: form.getStreetName,
                        placeholder: !form.streets ? "Loading..." : "Please select...",
                        xdQaName: "Find Building on Street"
                    })}
                </div>


                <div className="form-group">
                    {form.hasStreet() && <>
                        <div className="control-label">
                            Retrieve Addresses in Building
                        </div>
                        {Select({
                            list: form.buildings,
                            isSelected: form.isBuildingSelected,
                            onChange: form.onSelectBuilding,
                            itemToLabel: form.getBuildingName,
                            isDisabled: isBuildingExisted,
                            placeholder: form.buildingsError ? (
                                "Error!"
                            ) : !form.buildings ? (
                                "Loading..."
                            ) : (
                                "Please select..."
                            ),
                            xdQaName: "Retrieve Addresses in Building"
                        })}

                        {form.buildingsError && (
                            <div className="error">
                                ERROR: {form.buildingsError}
                            </div>
                        )}
                    </>}
                </div>
            </div>

            <div className="footer">
                <button {...{
                    className: "cancel",
                    onClick: () => modal.close(),
                    "xd-qa-type": "button",
                    "xd-qa-name": "Coop Condo List Add Address Cancel",
                }}>
                    Cancel
                </button>
                {cs(
                    ["submitting", (_, next) => UseState({next})],
                    ({submitting}) => (
                        <button {...{
                            className: cx("next", {}),
                            disabled: !form.ready || submitting.value,
                            onClick: async () => {
                                // apiError.onChange(null);
                                submitting.onChange(true);
                                try {
                                    await addBuilding(form.getValue());
                                    modal.close();
                                } finally {
                                    submitting.onChange(false);
                                }
                            },
                            "xd-qa-type": "button",
                            "xd-qa-name": "Coop Condo List Add Address",
                        }}>
                            Add
                        </button>
                    ),
                )}
            </div>
        </div>
    ),
);
